// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".enter-label[data-v-c0d60c0c]{background-color:var(--v-primary-base)}.enter-label[data-v-c0d60c0c],.leave-label[data-v-c0d60c0c]{border-radius:50%;color:#fff;font-weight:700;height:90px;line-height:90px;text-align:center;width:90px}.leave-label[data-v-c0d60c0c]{background-color:gray}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
